import React from "react";
import { Row, Col, Button } from 'react-bootstrap';
function Overview() {
    return (
        <div className="white-bg" style={{ padding: "20px" }}>
            <h2>Convocation Brochure - 2021</h2>
  

                <Row className='mb-5  mt-5 text-center'>

                    <Col  md={2} className="mb-3">

                        <span className="c-date">
                            SEP <br /> 25
                        </span>

                    </Col>

                    <Col md={10} className="mb-3 text-left">
                        <span> 2nd and 3rd (Joint) Convocation 2021, Chief Guest Shri B. Santhanam CEO - Asia Pacific and India Chairman, Saint-Gobain India.</span>
                    </Col>
                </Row>
            <h4> <a className="c-link" href="https://files.iittp.ac.in/pdfs/convocation/2021/Brochures-2021.pdf">Click here to view Convocation Brochure - 2021 </a></h4>
        </div>

        
    );
}

export default Overview;
